// extracted by mini-css-extract-plugin
export var buttons = "_bd-0";
export var buttonsActive = "_bd-h";
export var cancelConfirm = "_bd-1";
export var closeButton = "_bd-2";
export var column = "_bd-3";
export var container = "_bd-4";
export var detailHeader = "_bd-6";
export var detailTitle = "_bd-7";
export var detailsContent = "_bd-5";
export var header = "_bd-8";
export var headerWithClose = "_bd-9";
export var icon = "_bd-a";
export var infoIcon = "_bd-c";
export var informationContainer = "_bd-b";
export var sideDrawer = "_bd-d";
export var sideDrawerOpen = "_bd-e";
export var stickyFooter = "_bd-f";
export var typeOption = "_bd-g";